import React, { useContext } from 'react';
import Drawer from '@material-ui/core/Drawer';
import List from './List/index';
import AppContext from '../../../shared/contexts/AppContext';
import { DispatchActions } from '../../enums/DispatchActions';

const TemporaryDrawer = () => {
	const appContext = useContext(AppContext);
	const { openCart } = appContext.state;

	const toggleDrawer = () => {
		appContext.dispatch({ type: DispatchActions.CLOSE_CART });
	};

	return (
		<React.Fragment>
			<Drawer anchor='right' open={openCart} onClose={() => toggleDrawer()}>
				<List />
			</Drawer>
		</React.Fragment>
	);
};

export default TemporaryDrawer;
